import {onFind} from "@elements/init-modules-in-scope";
import {find,findIn, findAllIn, closest, on} from '@elements/dom-utils';
import asyncAppend from "@elements/async-append";
import axios from "axios";

const selectors = {
    base: '.js-payment',
    modificatorInput: '.js-payment__cart-modificator-input',
    voucher: '.js-payment__voucher-input',
    voucherWrapper: '.js-payment__voucher',
    voucherBtn: '.js-payment__voucher-btn',
    target: '.js-payment__result',
    loading: '.js-payment__loading'
};

export function init () {

    onFind(selectors.base, function (baseElement) {
        let modificatorInput = findAllIn(selectors.modificatorInput, baseElement);
        let cashbackURL = baseElement.dataset.paymentCartModificatorUrl;


        modificatorInput.map(function (input) {
            on('change', function (evt) {
                console.log("CHANGE");
                let pendingRequest = null;
                let name = input.dataset.cartModificatorName;

                let data = {
                    [name]: evt.target.checked
                }
                if (cashbackURL) {
                    pendingRequest = axios({method: 'POST', url: cashbackURL, data: data});
                    let results = findAllIn(selectors.target, baseElement);
                    let targetsByResultId = {};

                    results.forEach((element) => {
                        let resultId = element.dataset.resultId || 'default';
                        if (targetsByResultId[resultId]) {
                            targetsByResultId[resultId] = [...targetsByResultId[resultId], element];
                        } else {
                            targetsByResultId[resultId] = [element];
                        }
                    });

                    asyncAppend({
                        target: targetsByResultId,
                        loading: findAllIn(selectors.loading, baseElement),
                    }, pendingRequest.then((x) => x.data));
                } else {
                    console.warn("Cashback.js: no cashback remove Url set");
                }

            }, input);
        });


    });

    onFind(selectors.voucherWrapper, function (voucherWrapper) {
        let voucherBtns = findAllIn(selectors.voucherBtn, voucherWrapper);
        let baseElement = closest(selectors.base, voucherWrapper);
        let voucherURL = baseElement.dataset.paymentVoucherUrl;

        on('keydown', function(event){
            if(event.keyCode == 13) {
                event.preventDefault();
                return false;
            }
        }, window);

        voucherBtns.map(function(voucherBtn) {
            on('click', function(evt){
                console.log("clicked on button");
                evt.preventDefault();

                let voucherAction = evt.target.dataset.paymentVoucherAction || false;
                let voucherType = evt.target.dataset.paymentVoucherType || false;
                let voucherWrapper = closest(selectors.voucherWrapper, evt.target);
                let voucherInputData;

                if(!voucherAction) {
                    console.warn ("payment.js: no voucher action set");
                };

                if(voucherAction === 'remove') {
                    voucherInputData = evt.target.dataset.paymentVoucherRemoveId || null;
                } else {
                    voucherInputData = findIn(selectors.voucher, voucherWrapper).value;
                }


                let pendingRequestVoucher = null;

                let data = {
                    action: voucherAction,
                    ...voucherType && {type: voucherType},
                    voucher: voucherInputData
                };
                if(voucherURL) {
                    pendingRequestVoucher = axios({method: 'POST', url: voucherURL, data: data });
                    let results = findAllIn(selectors.target, baseElement);
                    let targetsByResultId = {};

                    results.forEach((element) => {
                        let resultId = element.dataset.resultId || 'default';
                        console.log(element);
                        console.log(targetsByResultId[resultId]);
                        if (targetsByResultId[resultId]) {
                            targetsByResultId[resultId] = [...targetsByResultId[resultId], element];
                        } else {
                            targetsByResultId[resultId] = [element];
                        }
                    });

                    asyncAppend({
                        target: targetsByResultId,
                        loading: findAllIn(selectors.loading, baseElement),
                    }, pendingRequestVoucher.then((x) => x.data));
                } else {
                    console.warn("Cashback.js: no cashback remove Url set");
                }
            }, voucherBtn);
        })

    });

}

